<template>
    <LoadingCard v-if="loading && !hasLoaded"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>Chemical Targets</h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new chemical target"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">
                    All Chemical Targets
                </h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>

            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields" :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit Chemical Target'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" @refresh="refetch" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" :target="editingTarget" v-model="editingTarget" v-if="editingTarget" />
    </div>
</template>

<script>
import listChemicalTargetsQuery from '@views/ChemicalTargets/Browse/queryListChemicalTargets.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseChemicalTargets',
  apollo: {
    targets: {
      query: listChemicalTargetsQuery,
      update: data => data.filterChemicalTargets.data,
      variables() {
        return {
          input: {
            include_deleted: true,
            page: this.pagination.page,
            limit: this.pagination.limit,
            sort: {
              direction: this.table.sortDesc
                ? 'DESC'
                : 'ASC',
              field: this.table.sortBy,
            },
          },
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.targets = data.filterChemicalTargets.data;
          this.pagination.page = data.filterChemicalTargets.meta.page;
          this.pagination.limit = data.filterChemicalTargets.meta.limit;
          this.pagination.total = data.filterChemicalTargets.meta.total;
          this.pagination.from = data.filterChemicalTargets.meta.from;
          this.pagination.to = data.filterChemicalTargets.meta.to;
        }
      },
    },
  },
  watch: {
    loading(newValue) {
      if (!this.hasLoaded && newValue === 0) {
        this.hasLoaded = true;
      }
    },
  },
  data() {
    return {
      targets: [],
      editingTarget: null,
      creating: false,
      loading: 0,
      hasLoaded: false,
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
        from: null,
        to: null,
      },
      table: {
        sortBy: 'name',
        sortDesc: false,
        fields: [
          {
            key: 'name',
            label: 'Chemical Target',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return (this.targets || []).map(item => ({
        ...item,
      }));
    },
  },
  methods: {
    refetch() {
      this.$apollo.queries.targets.refetch();
    },
    showEditDialog(target) {
      this.editingTarget = target;
    },
    closeEditDialog() {
      this.editingTarget = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
